// Auth API client.

import { apiFetch } from './api';

export interface AuthUser {
  id: number;
  email: string;
  displayName: string;
  roles: string[];
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const res = await apiFetch<{ status: 'ok'; user: AuthUser }>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  return res.user;
}

export async function logout(): Promise<void> {
  await apiFetch('/auth/logout', { method: 'POST' });
}

export async function refresh(): Promise<void> {
  await apiFetch('/auth/refresh', { method: 'POST' });
}

export interface AuthUserDetail extends AuthUser {
  firstName: string;
  lastName: string;
}

export async function fetchMe(): Promise<AuthUser> {
  const res = await apiFetch<{ status: 'ok'; user: AuthUser }>('/auth/me');
  return res.user;
}

export async function fetchMeDetail(): Promise<AuthUserDetail> {
  const res = await apiFetch<{ status: 'ok'; user: AuthUserDetail }>('/auth/me');
  return res.user;
}

export async function forgotPassword(email: string): Promise<void> {
  await apiFetch('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  await apiFetch('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, new_password: newPassword }),
  });
}

export async function updateProfile(input: { first_name?: string; last_name?: string; display_name?: string; email?: string }): Promise<void> {
  await apiFetch('/auth/me', {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiFetch('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  });
}
